import { Controller } from "@hotwired/stimulus"
import telemetry from "../telemetry"

export default class extends Controller {
  static values = { event: String, params: Object }

  track() {
    if (this.hasEventValue) telemetry.track(this.eventValue, this.paramsValue || {})
  }
}
